import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { LectionaryItemMap } from 'app/objects';

@Injectable()
export class MappingsService {

  constructor(private apiSvc: ApiService) { }

  public getMappings(serviceId: string): Promise<LectionaryItemMap[]> {

    const p = new Promise<LectionaryItemMap[]>((resolve, reject) => {

      this.apiSvc.get("api/lectionaryitemmap/getbyservice/" + serviceId, null).subscribe(
        (data: LectionaryItemMap[]) => {
          console.log("/lectionaryitemmap/getbyservice", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

  public getMappingsForProper(properId: string): Promise<LectionaryItemMap[]> {

    const p = new Promise<LectionaryItemMap[]>((resolve, reject) => {

      this.apiSvc.get("api/lectionaryitemmap/getbyproper/" + properId, null).subscribe(
        (data: LectionaryItemMap[]) => {
          console.log("/lectionaryitemmap/getbyproper", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

    });

    return p;
  }

  public getMappingsForLectionaryItemName(lectionaryItemNameId: number): Promise<LectionaryItemMap[]> {

    const p = new Promise<LectionaryItemMap[]>((resolve, reject) => {
 
      this.apiSvc.get("api/lectionaryitemmap/getbylectionaryitemname/" + lectionaryItemNameId, null).subscribe(
        (data: LectionaryItemMap[]) => {
          console.log("/lectionaryitemmap/getbylectionaryitemname", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

    });

    return p;
  }

  public save(map: LectionaryItemMap): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {
 
      this.apiSvc.post("api/lectionaryitemmap/save/", map).subscribe(
        () => {
          resolve();
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

    });

    return p;
  }

  public delete(map: LectionaryItemMap): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {

      this.apiSvc.post("api/lectionaryitemmap/delete/", {Id: map.Id}).subscribe(
        () => {
          resolve();
        },
        (err) => {
          console.log("error", err);
          reject(err);
        }
      );

    });

    return p;
  }
}


